var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import qs from 'query-string';
import createClient from './interceptors';
import { getAuthBaseUrl } from './microservicesConfig';
const AUTH_BASE_URL = getAuthBaseUrl();
const authService = createClient(AUTH_BASE_URL);
export const refreshTokenPostCall = (refreshToken, clientId) => __awaiter(void 0, void 0, void 0, function* () {
    return authService({
        method: 'post',
        url: 'auth/realms/global/protocol/openid-connect/token',
        data: qs.stringify({
            grant_type: 'refresh_token',
            client_id: clientId || 'login',
            refresh_token: refreshToken,
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
});
//# sourceMappingURL=authApi.js.map